import { SxProps, Theme } from '@mui/material';

import { HealthCheckSeverity } from '../../LegalTransaction/HealthCheck/types';

/**
 * Gemeinsame Darstellungsvorgaben der Regelliste (#1283).
 *
 * Kopfzeile und Regelzeilen teilen sich dieselbe Grid-Definition — sonst
 * fluchten Ueberschrift und Inhalt nur zufaellig und laufen beim naechsten
 * Eingriff auseinander.
 */

/**
 * Spalten der Regelliste.
 *
 * Gespeichert wird gemeinsam ueber die Kopfleiste, deshalb hat die Zeile keine
 * Aktionsspalte mehr.
 *
 * Ab `lg` die volle Tabelle. Darunter stapeln sich die Bedienelemente unter
 * dem Titel — die Spalte „Pruefung" braucht Platz fuer Titel und Beschreibung,
 * und drei Radiobuttons plus zwei Auswahlfelder daneben passen auf einem
 * schmalen Fenster nicht nebeneinander, ohne zu ueberlappen.
 *
 * Keine Spalte darf sich am Inhalt bemessen. Kopfzeile und Regelzeilen sind
 * zwei getrennte Grid-Container: `auto` wuerde in jedem neu gemessen, die
 * Kopfzeile richtete sich nach dem Wort „Aktiv" und die Zeilen nach der Breite
 * des Schalters — die Ueberschrift „Pruefung" stuende dann links neben ihrer
 * Spalte, halb ueber dem Schalter.
 */
export const HEALTH_CHECK_ROW_GRID: SxProps<Theme> = {
  display: 'grid',
  columnGap: 2,
  rowGap: 0.5,
  gridTemplateColumns: {
    // 58px ist die Breite des MUI-Switch in Normalgroesse.
    xs: '58px minmax(0, 1fr)',
    lg: '58px minmax(240px, 1fr) 168px 208px 208px',
  },
  gridTemplateAreas: {
    xs: `"active rule"
         "blank level"
         "blank scope"
         "blank types"
         "sub sub"`,
    lg: `"active rule level scope types"
         "blank sub sub sub sub"`,
  },
};

/** Kurzform fuer den Chip am Titel — die Zeile soll nicht zulaufen. */
export const SEVERITY_SHORT_LABEL: Record<HealthCheckSeverity, string> = {
  info: 'Hinweis',
  warning: 'Warnung',
  error: 'Fehler',
};

/**
 * Beschriftung im Auswahlfeld. Bei `info` mit der Folge im Text, weil genau
 * das der Grund ist, eine Pruefung auf diese Stufe zu stellen.
 */
export const SEVERITY_OPTION_LABEL: Record<HealthCheckSeverity, string> = {
  info: 'Hinweis (zählt nicht als Warnung)',
  warning: 'Warnung',
  error: 'Fehler',
};

export const SEVERITY_CHIP_COLOR: Record<
  HealthCheckSeverity,
  'default' | 'warning' | 'error'
> = {
  info: 'default',
  warning: 'warning',
  error: 'error',
};
